import { api } from './api.ts';

// Download a file from an authenticated endpoint. A plain <a href> navigation
// can't send the app's Bearer token (login stores it, there's no auth cookie),
// so we fetch via axios — which adds the token and refreshes on 401 — then save
// the blob client-side, using the server's Content-Disposition filename (or a
// fallback). `path` is relative to the axios baseURL (`/api`).
export async function downloadFile(path: string, fallbackName: string): Promise<void> {
  const res = await api.get<Blob>(path, { responseType: 'blob' });
  const cd = String(res.headers['content-disposition'] ?? '');
  const match = cd.match(/filename="?([^"]+)"?/);
  const filename = match?.[1] ?? fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
